const show = {
  id: 'show',
};

const icon = {
  id: 'icon',
};

export default { show, icon };
